import {
  Button,
  Col,
  Container,
  FloatingLabel,
  Form,
  Row,
} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocalizedRoutes } from '../../hooks/useLocalizedRoutes';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axiosApi from '../../axios/axios-api';
import { LogoPetroprix } from '../ui/LogoPetroprix';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import Feedback from 'react-bootstrap/esm/Feedback';
import checkMatricula from '../../functions/checkMatricula';
import { ValidateToken } from '../../helpers/validateToken';
import { startLogout } from '../../store/auth';
import { MiniLoader } from '../ui/MiniLoader';

const URL_GET_ESTADO_CUENTA = 'cliente/estadoCuenta';

export const NuevoVehiculo = () => {
  const { t } = useTranslation();
  const { getPath } = useLocalizedRoutes();

  const { token } = useSelector((state) => state.auth);

  const [validated, setValidated] = useState(false);
  const [validatingMatricula, setValidatingMatricula] = useState(false);
  const [savingData, setSavingData] = useState(false);
  const [blockButton, setBlockButton] = useState(true);
  const [vehicleData, setVehicleData] = useState({
    matricula: '',
    tipo_vehiculo: '',
    tipo: '',
  });

  const [formErrors, setFormErrors] = useState({
    matricula: '',
    tipo_vehiculo: '',
    tipo: '',
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const checkButtonDisabled = () => {
    if (
      vehicleData.matricula &&
      vehicleData.tipo_vehiculo &&
      vehicleData.tipo
    ) {
      setBlockButton(false);
    } else {
      setBlockButton(true);
    }
    //Comprobamos si el tipo de vehículo es una moto y si es así, cambiamos el tipo de combustible a gasolina
    if (vehicleData.tipo_vehiculo === '1') {
      vehicleData.tipo = 'Gasolina';
    }
  };

  const validateMatricula = async () => {
    setValidatingMatricula(true);

    if (vehicleData.matricula === '') {
      setFormErrors((prevState) => ({
        ...prevState,
        matricula: false,
      }));
      setValidatingMatricula(false);
    } else {
      await checkMatricula(vehicleData.matricula, token).then(
        (matriculaValida) => {
          if (matriculaValida?.code !== 200) {
            setFormErrors((prevState) => ({
              ...prevState,
              matricula: false,
            }));
            setValidatingMatricula(false);
          } else {
            setFormErrors((prevState) => ({
              ...prevState,
              matricula: true,
            }));
            setValidatingMatricula(false);
          }
        }
      );
    }
  };

  const validateForm = async () => {
    setValidated(false);

    validateForm.matricula =
      vehicleData.matricula !== '' && formErrors.matricula;
    validateForm.tipo_vehiculo = vehicleData.tipo_vehiculo !== '';
    validateForm.tipo = vehicleData.tipo !== '';

    validateMatricula();

    // Verificar si hay errores
    if (Object.values(validateForm).some((value) => value === false)) {
      const campoInvalido = Object.keys(validateForm).find(
        (key) => validateForm[key] === false
      );
      setSavingData(false);
      return false;
    }

    setValidated(true);
    return true;
  };

  useEffect(() => {
    checkButtonDisabled();
  }, [vehicleData]);

  const addVehiculo = async (e) => {
    e.preventDefault();
    setSavingData(true);

    let formValid = await validateForm();

    if (!formValid) {
      setBlockButton(true);
      setSavingData(false);
      return false;
    }

    // Creamos el objeto con los datos del vehículo
    const data = {
      matricula: vehicleData.matricula,
      tipo_vehiculo: vehicleData.tipo_vehiculo,
      tipo: vehicleData.tipo,
    };

    try {
      if (process.env.REACT_APP_URL_API && ValidateToken()) {
        const response = await axiosApi.post(`vehiculos`, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
          },
        });
        if (response?.data?.code === 201) {
          toast(t('datos.vehiculos.nuevo.form.result.ok'), {
            icon: <LogoPetroprix />,
          });
          setBlockButton(false);
          setSavingData(false);
          if (ValidateToken()) {
            navigate(getPath('home'));
          } else {
            dispatch(startLogout('expired'));
          }
        } else {
          toast(response.data.message, {
            icon: <LogoPetroprix />,
          });
          setBlockButton(false);
          setSavingData(false);
        }
      } else {
        dispatch(startLogout('expired'));
      }
    } catch (error) {
      setBlockButton(false);
      console.error(error);
      setSavingData(false);
    }
  };

  const fetchEstadoCuenta = useCallback(async () => {
    try {
      if (process.env.REACT_APP_URL_API && ValidateToken()) {
        const response = await axiosApi.get(URL_GET_ESTADO_CUENTA, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
          },
        });
        if (response?.data?.code === 200) {
          if (response.data.data.bloqueada === 1) {
            if (ValidateToken()) {
              navigate(getPath('home'));
            } else {
              dispatch(startLogout('expired'));
            }
            toast(t('datos.alert.bloqueado.limite.text'));
          }
        }
      } else {
        dispatch(startLogout('expired'));
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    fetchEstadoCuenta();
  }, [fetchEstadoCuenta]);

  return (
    <>
      <Container className='content-body '>
        <Container>
          <Row className='content-section pt-5 mb-4'>
            <Form
              className='datos-nuevo-vehiculo'
              autoComplete='off'
              noValidate
              validated={validated}
              onSubmit={(e) => {
                addVehiculo(e);
              }}
            >
              <Row>
                <Col sm={12} lg={6}>
                  <FloatingLabel
                    label={t('datos.vehiculos.nuevo.form.matricula')}
                    className='mb-3'
                  >
                    <Form.Control
                      type='text'
                      maxLength='12'
                      id='matricula'
                      placeholder={t('datos.vehiculos.nuevo.form.matricula')}
                      onBlur={validateMatricula}
                      onChange={(e) => {
                        setVehicleData((prevState) => ({
                          ...prevState,
                          matricula: e.target.value.toUpperCase(),
                        }));
                      }}
                      isInvalid={
                        !validatingMatricula && formErrors.matricula === false
                      }
                      isValid={
                        !validatingMatricula && formErrors.matricula === true
                      }
                    />
                    {validatingMatricula && (
                      <>
                        <div className='datos-form-validating'>
                          <MiniLoader />
                        </div>
                        <p className='datos-form-validating-text'>
                          {t('datos.vehiculos.nuevo.form.validating.matricula')}
                        </p>
                      </>
                    )}

                    <Feedback type='invalid' id='matricula-feedback'>
                      {t('datos.vehiculos.nuevo.form.matricula.invalid')}
                    </Feedback>
                  </FloatingLabel>
                </Col>

                <Col sm={12} lg={6}>
                  <FloatingLabel
                    label={t('datos.vehiculos.nuevo.form.tipo-vehiculo')}
                    className='mb-3'
                  >
                    <Form.Select
                      aria-label={t('datos.vehiculos.nuevo.form.tipo-vehiculo')}
                      id='tipo-vehiculo'
                      placeholder={t(
                        'datos.vehiculos.nuevo.form.tipo-vehiculo'
                      )}
                      defaultValue=''
                      onChange={(e) => {
                        setVehicleData((prevState) => ({
                          ...prevState,
                          tipo_vehiculo: e.target.value,
                        }));
                      }}
                      isInvalid={validated && formErrors.tipo_vehiculo}
                      isValid={validated && !formErrors.tipo_vehiculo}
                    >
                      <option value='' disabled>
                        {t('datos.vehiculos.nuevo.form.tipo-vehiculo.select')}
                      </option>
                      <option value='0'>
                        {t('datos.vehiculos.nuevo.form.tipo-vehiculo.turismo')}
                      </option>
                      <option value='1'>
                        {t('datos.vehiculos.nuevo.form.tipo-vehiculo.moto')}
                      </option>
                      <option value='2'>
                        {t('datos.vehiculos.nuevo.form.tipo-vehiculo.camion')}
                      </option>
                    </Form.Select>
                    <Feedback type='invalid'>
                      {t('datos.vehiculos.nuevo.form.tipo-vehiculo.invalid')}
                    </Feedback>
                  </FloatingLabel>
                </Col>

                <Col sm={12} lg={6}>
                  <FloatingLabel
                    label={t('datos.vehiculos.nuevo.form.combustible')}
                    className='mb-3'
                  >
                    <Form.Select
                      aria-label={t('datos.vehiculos.nuevo.form.combustible')}
                      id='tipo'
                      placeholder={t('datos.vehiculos.nuevo.form.combustible')}
                      defaultValue=''
                      onChange={(e) => {
                        setVehicleData((prevState) => ({
                          ...prevState,
                          tipo: e.target.value,
                        }));
                      }}
                      isInvalid={validated && formErrors.tipo}
                      isValid={validated && !formErrors.tipo}
                    >
                      <option value='' disabled>
                        {t('datos.vehiculos.nuevo.form.combustible.select')}
                      </option>
                      <option value='Diesel'>
                        {t('datos.vehiculos.nuevo.form.combustible.diesel')}
                      </option>
                      <option value='Gasolina'>
                        {t('datos.vehiculos.nuevo.form.combustible.gasolina')}
                      </option>
                    </Form.Select>
                    <Feedback type='invalid'>
                      {t('datos.vehiculos.nuevo.form.combustible.invalid')}
                    </Feedback>
                  </FloatingLabel>
                </Col>
              </Row>
              <Row>
                <div className='d-grid gap-2 mt-5'>
                  <Button
                    id='btn-add-vehiculo'
                    variant='primary'
                    size='lg'
                    onClick={(e) => {
                      addVehiculo(e);
                    }}
                    disabled={savingData || blockButton || validatingMatricula}
                  >
                    {savingData ? (
                      <MiniLoader />
                    ) : (
                      t('datos.vehiculos.nuevo.form.guardar-btn')
                    )}
                  </Button>
                </div>
              </Row>
            </Form>
          </Row>
        </Container>
      </Container>
    </>
  );
};
